import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

// @dynamic
@Component({
  selector: 'sc-success-dialog',
  templateUrl: './sc-success-dialog.component.html',
  styleUrls: ['./sc-success-dialog.component.scss']
})
export class ScSuccessDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ScSuccessDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      successMessage: {
        title: string;
        message: string;
      };
    }
  ) {}
}
